import { ReactNode } from 'react';
import { SubscriptionStatusesEnum } from '@thinknet-gmbh/platform-common';

import { useGetCurrentSubscription } from 'src/hooks/subscriptions/get-current-subscription.hook';
import SoftwarePlansModal from 'src/components/software-plans-modal/software-plans-modal.component';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';

const SubscriptionProvider = ({ children }: { children: ReactNode }) => {
  const { subscription, loading } = useGetCurrentSubscription();
  const { _id: subscriptionId, subscriptionType, status, usedEmployeesPlacesCount } = subscription;

  const { account } = useGetCurrentAccount();

  return (
    <>
      {subscriptionType &&
        !loading &&
        status !== SubscriptionStatusesEnum.ACTIVE &&
        !account.canContinueWorking && (
          <SoftwarePlansModal
            subscriptionId={subscriptionId}
            usedEmployeesPlacesCount={usedEmployeesPlacesCount}
          />
        )}
      {children}
    </>
  );
};

export default SubscriptionProvider;
